<template>
    <div>
        <div class="empty-page" :style="{ height: height + 'px'}" v-show="!loading">
            <img :class="size" src="../assets/images/empty.png" alt="" />
            <span>{{ text }}</span>
        </div>
        <div class="loading-page" :style="{ height: height + 'px'}" v-show="loading">
            <i class="el-icon-loading"></i>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'EmptyPage',
        props: {
            size: {
                type: String,
                default: 'default'
            },
            height: {
                type: Number,
                default: 300
            },
            loading: {
                type: Boolean,
                default: false
            },
            text: {
                type: String,
                default: '暂无数据'
            }
        }
    };
</script>

<style lang="scss" scoped>
    .empty-page {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;

        img {
            width: 180px;

            &.small {
                width: 120px;
            }
        }

        span {
            margin-top: 20px;
            margin-left: -10px;
            @include font(#8086B8, 14px, 400);
        }
    }

    .loading-page {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 32px;
    }
</style>
